/**
 * Reduced motion arrives on two independent channels and both are load-bearing:
 * the OS media query, and the in-app preference that layout.tsx stamps onto
 * <html> as data-reduced-motion. canvas-confetti's own disableForReducedMotion
 * option only knows about the first one, so everything routes through here.
 */
export function prefersReducedMotion(): boolean {
  if (typeof window === "undefined") return true;
  if (document.documentElement.dataset.reducedMotion === "true") return true;
  return window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false;
}
